import '../styles/tagsAndMentions.scss';

export default function TopHashtagsCard({ tags }) {
  if (!tags || tags?.length === 0) {
    return null;
  }
  return (
    <div className="demographics-card">
      <h2>Top Hashtags Used</h2>
      <div className="tags-container">
        {tags && tags.slice(0, 15).map((tag, index) => <TagPill key={index} tag={tag.tag} />)}
      </div>
    </div>
  );
}

const TagPill = ({ tag }) => {
  return <span className="tag-pill">#{tag}</span>;
};
